import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSearch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.7188 17.3086L13.0078 12.5977C14.0273 11.3672 14.5898 9.78516 14.5898 8.0625C14.5898 4.05469 11.2852 0.75 7.27734 0.75C3.23438 0.75 0 4.05469 0 8.0625C0 12.1055 3.26953 15.375 7.27734 15.375C8.96484 15.375 10.5469 14.8125 11.8125 13.793L16.5234 18.5039C16.6992 18.6797 16.9102 18.75 17.1562 18.75C17.3672 18.75 17.5781 18.6797 17.7188 18.5039C18.0703 18.1875 18.0703 17.6602 17.7188 17.3086ZM1.6875 8.0625C1.6875 4.96875 4.18359 2.4375 7.3125 2.4375C10.4062 2.4375 12.9375 4.96875 12.9375 8.0625C12.9375 11.1914 10.4062 13.6875 7.3125 13.6875C4.18359 13.6875 1.6875 11.1914 1.6875 8.0625Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconSearch);
export { ForwardRef as ReactComponent };
